import { createSlice } from '@reduxjs/toolkit';
import { StudiosSearchTypes } from 'src/components/ToggleBox/ToggleBox.types';
import { SortTypes } from 'src/screens/studios/StudiosScreen.types';

import { InitialStudiosStateType } from '../types/studiosTypes';
const name = 'studios';

const INITIAL_STATE: InitialStudiosStateType = {
  studios: [],
  currentStudio: null,
  filteredStudios: [],
  isStudiosLoading: false,
  isStudioLoading: false,
  isFilteredStudiosLoading: false,
  selectedToggleBoxValue: StudiosSearchTypes.NAME,
  sortByValue: SortTypes.NAME,
  searchInputValue: '',
  searchParams: { orderBy: 'title' },
  error: null,

  isCreateRequestLoading: false,
  isUpdateRequestLoading: false,
  isRemoveRequestLoading: false,
  isPublishRequestLoading: false,
};

const studiosSlice = createSlice({
  name,
  initialState: INITIAL_STATE,
  reducers: {
    updateSearchParams: (state, action) => {
      state.searchParams = action.payload;
    },

    getStudios: state => {
      state.isStudiosLoading = true;
    },
    getStudiosSuccess: (state, action) => {
      state.isStudiosLoading = false;
      state.studios = action.payload;
    },
    getStudiosFailure: (state, action) => {
      state.isStudiosLoading = false;
      state.error = action.payload;
    },

    getStudioById: (state, action) => {
      state.isStudioLoading = true;
    },
    getStudioByIdSuccess: (state, action) => {
      state.isStudioLoading = false;
      state.currentStudio = action.payload;
    },
    getStudioByIdFailure: (state, action) => {
      state.isStudioLoading = false;
      state.error = action.payload;
    },

    getFilteredStudios: (state, action) => {
      state.isFilteredStudiosLoading = true;
    },
    getFilteredStudiosSuccess: (state, action) => {
      state.isFilteredStudiosLoading = false;
      state.filteredStudios = action.payload;
    },
    getFilteredStudiosFailure: (state, action) => {
      state.isFilteredStudiosLoading = false;
      state.error = action.payload;
    },

    createStudios: (state, action) => {
      state.isCreateRequestLoading = true;
    },
    createStudiosSuccess: state => {
      state.isCreateRequestLoading = false;
    },
    createStudiosFailure: (state, action) => {
      state.isCreateRequestLoading = false;
      state.error = action.payload;
    },

    updateStudios: (state, action) => {
      state.isUpdateRequestLoading = true;
    },
    updateStudiosSuccess: state => {
      state.isUpdateRequestLoading = false;
    },
    updateStudiosFailure: (state, action) => {
      state.isUpdateRequestLoading = false;
      state.error = action.payload;
    },

    removeStudios: (state, action) => {
      state.isRemoveRequestLoading = true;
    },
    removeStudiosFailure: (state, action) => {
      state.isRemoveRequestLoading = false;
      state.error = action.payload;
    },
    removeStudiosSuccess: state => {
      state.isRemoveRequestLoading = false;
    },

    publishStudio: (state, action) => {
      state.isPublishRequestLoading = true;
    },
    publishStudioFailure: (state, action) => {
      state.isPublishRequestLoading = false;
      state.error = action.payload;
    },
    publishStudioSuccess: state => {
      state.isPublishRequestLoading = false;
    },
  },
});

export const {
  updateSearchParams,

  getStudios,
  getStudiosFailure,
  getStudiosSuccess,

  getStudioById,
  getStudioByIdSuccess,
  getStudioByIdFailure,

  getFilteredStudios,
  getFilteredStudiosSuccess,
  getFilteredStudiosFailure,

  createStudios,
  createStudiosSuccess,
  createStudiosFailure,

  updateStudios,
  updateStudiosSuccess,
  updateStudiosFailure,

  removeStudios,
  removeStudiosFailure,
  removeStudiosSuccess,

  publishStudio,
  publishStudioFailure,
  publishStudioSuccess,
} = studiosSlice.actions;

export default studiosSlice.reducer;
